<template>
    <template v-if="!authRoutes.includes($route.name)">
        <div
            id="main_wrap"
            v-show="loaded"
            :class="{ mobile_sidebar_open: isCompactViewport && isSidebarOpen }"
        >
            <header-component
                :isCompactViewport="isCompactViewport"
                @toggleSidebar="toggleSidebar"
            />
            <sidebar-component @navigate="closeSidebar" />
            <button
                v-if="isCompactViewport && isSidebarOpen"
                type="button"
                class="mobile_sidebar_overlay"
                aria-label="Close navigation"
                @click="closeSidebar"
            ></button>
            <div id="content_wrap">
                <div class="container-fluid">
                    <router-view v-if="loaded"></router-view>
                </div>
            </div>
        </div>
    </template>
    <router-view v-else></router-view>
</template>

<script>
import HeaderComponent from './components/shared/HeaderComponent';
import SidebarComponent from './components/shared/SidebarComponent.vue';
// import store from "@/store";
import {mapGetters} from "vuex";
import {ABILITY_TOKEN, useAbility} from "@casl/vue";
import {AbilityBuilder, createMongoAbility} from "@casl/ability";

export default {
  inject: {
    ability: { from: ABILITY_TOKEN }
  },
    components: {HeaderComponent, SidebarComponent},
    name: 'App',
  setup() {
    const { can } = useAbility();

    return {
      can
    };
  },
    data() {
        return {
          loaded: false,
          viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1440,
          isSidebarOpen: false,
          authRoutes: ['login', 'register', 'email-verification', 'forgot-password', 'reset-password'],
        }
    },
    watch: {
        $route() {
            this.closeSidebar();
            this.syncBodyScrollLock();
        },
    },
  computed: {
    containerClass() {
      return this.$route.name === 'dashboard' ? 'container' : 'ticket_common_page';
    },
    isCompactViewport() {
      return this.viewportWidth < 1200;
    },
    ...mapGetters({
      permission: "auth/permissionList",
      customer: 'auth/getUserInfo',
    })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('keydown', this.handleKeydown);
    document.body.classList.remove('mobile_panel_lock');
  },
  async mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('keydown', this.handleKeydown);

    try {
      const { data } = await this.axios('/customer');

      // Await each dispatch to ensure it's fully processed before moving to the next
      await this.$store.dispatch('auth/setCustomer', data);
      await this.$store.dispatch('auth/customerInfo', data);
      // await this.$store.dispatch('auth/customerServices');
      // await this.$store.dispatch('auth/getPermissions');
      // await this.$store.dispatch('serverPermissions/servicePermissionList');

      // Use a setTimeout for permission checks after dispatches are complete

      const { can, rules } = new AbilityBuilder(createMongoAbility);
      can(this.permission);
      this.ability.update(rules);

    } catch (error) {
      // Handle error by logging out and redirecting to login
      if(!['register','email-verification','forgot-password','reset-password'].includes(this.$route.name)){
        this.$store.dispatch('auth/logout');
        this.$router.push({ name: 'login' });
      }
      
    } finally {
      // Mark the component as loaded
      this.loaded = true;
    }

    // Call sidebar toggler
    this.sidebarToggler();
  },
  methods: {
    handleResize() {
      this.viewportWidth = window.innerWidth;

      if (!this.isCompactViewport) {
        this.isSidebarOpen = false;
      }

      this.syncBodyScrollLock();
    },
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.closeSidebar();
      }
    },
    toggleSidebar() {
      if (!this.isCompactViewport) {
        return;
      }

      this.isSidebarOpen = !this.isSidebarOpen;
      this.syncBodyScrollLock();
    },
    closeSidebar() {
      if (!this.isSidebarOpen) {
        return;
      }

      this.isSidebarOpen = false;
      this.syncBodyScrollLock();
    },
    syncBodyScrollLock() {
      document.body.classList.toggle(
        'mobile_panel_lock',
        this.isCompactViewport && this.isSidebarOpen && !this.authRoutes.includes(this.$route.name)
      );
    }
  }
}
</script>

<style>

</style>
